import { alpha, Theme } from '@mui/material/styles';

import View from '@egr/xbox/egr-gui-elements/Views/View';
import { StyleRules, withStyles } from '@egr/xbox/utils/tss-react';

type ViewClasses = 'root' | 'transition' | 'hideByMove' | 'hideByVisibility';

function getViewStyles(theme: Theme): StyleRules<{}, ViewClasses> {
    return {
        transition: {
            transition: 'transform 330ms',
        },
        root: {
            transition: 'transform 330ms',
            alignItems: 'stretch',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            maxHeight: '100%',
            width: '100%',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            position: 'absolute',
            top: 0,
            zIndex: 1,
            overflow: 'hidden',
            '&-default': {
                backgroundColor: theme.palette.background.default,
            },
            '&-primary': {
                backgroundColor: alpha(theme.palette.primary.main, .3),
            },
            '&-grey': {
                backgroundColor: theme.palette.grey[300],
            },
            '&-dark': {
                backgroundColor: theme.palette.grey[500],
            },
        },
        hideByMove: {
            transform: 'translate3d(0, 100vh, 0)',
            zIndex: 0,
        },
        hideByVisibility: {
            visibility: 'hidden',
            zIndex: 0,
        }
    };
}

export default withStyles(View, getViewStyles);
